module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-hcuat-api.rugcc.org/api/v1",
        current_environment : "hcuat"
    }
};